export default "__VITE_ASSET__Breywf9z__"